import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-brand-black border-t border-brand-gold/20 pt-16 pb-8" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-8" data-id="element-165">
          {/* Brand Column */}
          <div className="md:col-span-12 lg:col-span-4" data-id="element-166">
            <Link to="/" className="inline-block mb-4" data-id="element-167">
              <span className="font-heading text-2xl font-semibold text-brand-gold tracking-wide" data-id="element-168">
                Deluxe MedSpa Beauty
              </span>
            </Link>
            <p className="text-brand-champagne-light/80 text-sm leading-relaxed max-w-xs" data-id="element-169">
              Your trusted destination for beauty and wellness in Miami.
            </p>
          </div>

          {/* Links Column 1 */}
          <div className="md:col-span-4 lg:col-span-2" data-id="element-170">
            <h3 className="font-heading text-lg text-brand-white mb-4" data-id="element-171">
              Explore
            </h3>
            <ul className="space-y-3" data-id="element-172">
              <li data-id="element-173">
                <Link to="/#treatments" className="text-sm text-brand-champagne-light/70 hover:text-brand-gold transition-colors" data-id="element-174">
                  Treatments
                </Link>
              </li>
              <li data-id="element-175">
                <Link to="/#about" className="text-sm text-brand-champagne-light/70 hover:text-brand-gold transition-colors" data-id="element-176">
                  About
                </Link>
              </li>
              <li data-id="element-177">
                <Link to="/contact" className="text-sm text-brand-champagne-light/70 hover:text-brand-gold transition-colors" data-id="element-178">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Links Column 2 (Compliance) */}
          <div className="md:col-span-4 lg:col-span-3" data-id="element-179">
            <h3 className="font-heading text-lg text-brand-white mb-4" data-id="element-180">
              Legal & Compliance
            </h3>
            <ul className="space-y-3" data-id="element-181">
              <li data-id="element-182">
                <Link to="/privacy-policy" className="text-sm text-brand-champagne-light/70 hover:text-brand-gold transition-colors" data-id="element-183">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-184">
                <Link to="/terms-conditions" className="text-sm text-brand-champagne-light/70 hover:text-brand-gold transition-colors" data-id="element-185">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-186">
                <Link to="/sms-terms" className="text-sm text-brand-champagne-light/70 hover:text-brand-gold transition-colors" data-id="element-187">
                  SMS Terms & Consent
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="md:col-span-4 lg:col-span-3" data-id="element-188">
            <h3 className="font-heading text-lg text-brand-white mb-4" data-id="element-189">
              Visit Us
            </h3>
            <address className="not-italic text-sm text-brand-champagne-light/70 space-y-2" data-id="element-190">
              <p data-id="element-191">Deluxe MedSpa Beauty</p>
              <p data-id="element-192">30 SW 1st St #1001</p>
              <p data-id="element-193">Miami, FL 33132</p>
              <p className="pt-2" data-id="element-194">
                <a href="tel:786-901-0611" className="hover:text-brand-gold transition-colors" data-id="element-195">
                  Phone: 786-901-0611
                </a>
              </p>
            </address>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-brand-charcoal text-center md:text-left flex flex-col md:flex-row justify-between items-center" data-id="element-196">
          <p className="text-xs text-brand-champagne-light/50" data-id="element-197">
            &copy; 2026 Deluxe MedSpa Beauty. All Rights Reserved.
          </p>
          <p className="text-xs text-brand-champagne-light/40 mt-4 md:mt-0" data-id="element-198">
            Designed for compliance and excellence.
          </p>
        </div>
      </div>
    </footer>;
}